var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.576 11.685 4.275 4.275a.4.4 0 0 1 0 .563l-.328.328a.4.4 0 0 1-.563 0l-4.275-4.275a.4.4 0 0 1-.116-.282v-.338A6.892 6.892 0 0 1 0 6.892 6.89 6.89 0 0 1 6.893 0a6.892 6.892 0 0 1 5.06 11.569h.341c.106 0 .206.04.282.116M1.06 6.893a5.83 5.83 0 0 0 5.833 5.832 5.83 5.83 0 0 0 5.832-5.832A5.83 5.83 0 0 0 6.893 1.06 5.83 5.83 0 0 0 1.06 6.893",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;